import { ITab } from 'helpers/tabs';
import React from 'react';
import { useLocation } from 'react-router-dom';
import PageHero from 'components/PageHero';

interface IPage {
    tabs?: ITab[]
    children?: React.ReactNode
    eyebrow?: string
    title?: string
    lead?: React.ReactNode
    visual?: string
    visualAlt?: string
    watermark?: boolean
    watermarkSrc?: string
}

const Page = ({ tabs, children, eyebrow, title, lead, visual, visualAlt, watermark, watermarkSrc }: IPage) => {
    const location = useLocation();
    const currentPath = location.pathname.replace(/\/$/, '');
    return (
        <>
            {title && (
                <PageHero
                    eyebrow={eyebrow}
                    title={title}
                    lead={lead}
                    visual={visual}
                    visualAlt={visualAlt}
                    watermark={watermark}
                    watermarkSrc={watermarkSrc}
                />
            )}
            <div className={`service-single-section${tabs && tabs.length > 0 ? ' has-index' : ''}`}>
                <div className="container">
                    {tabs && tabs.length > 0 &&
                        <aside className="service-single-sidebar">
                            <div className="page-index">
                                <p className="page-index-label">In questa sezione</p>
                                <nav className="service-details-listing">
                                    {tabs.map((t, ix) =>
                                        <a
                                            key={ix}
                                            href={t.url}
                                            className={currentPath === t.url.replace(/\/$/, '') ? 'is-active' : ''}
                                        >{t.title}</a>
                                    )}
                                </nav>
                            </div>
                        </aside>
                    }
                    <div className="service-single-contentarea">
                        {children}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
